import ReactQuill from "react-quill";
import React from "react";

import "react-quill/dist/quill.snow.css";

const EditorInput = ({
  onChange,
  defaultValue,
}: {
  onChange: (value: string) => void;
  defaultValue: string;
}) => {
  return (
    <ReactQuill
      theme="snow"
      defaultValue={defaultValue}
      style={{ backgroundColor: "white" }}
      onChange={(value) => (value !== undefined ? onChange(value) : null)}
    />
  );
};

export default EditorInput;
